import { getKerioFilters, setKerioFilters, } from "@apps/client-sdk";
import { renderKerioBuilderUi } from "./kerioUi.js";
import { el } from "../dom.js";
import { isKerioAuthError, renderKerioPasswordUpdate, } from "./kerioPasswordUpdate.js";
function fromApi(rule) {
    return {
        id: rule.id,
        isEnabled: rule.isEnabled,
        description: rule.description || "",
        isIncomplete: Boolean(rule.isIncomplete),
        conditions: (rule.conditions || []).map((c) => ({
            testedTarget: c.testedTarget,
            comparator: c.comparator,
            parameters: [...(c.parameters || [])],
        })),
        actions: (rule.actions || []).map((a) => ({
            type: a.type,
            parameters: [...(a.parameters || [])],
        })),
        evaluationMode: rule.evaluationMode === "EmAnyOf" ? "EmAnyOf" : "EmAllOf",
    };
}
function toApi(rule) {
    return {
        id: rule.id,
        isEnabled: rule.isEnabled,
        description: rule.description,
        isIncomplete: rule.isIncomplete,
        conditions: rule.conditions.map((c) => ({
            testedTarget: c.testedTarget,
            comparator: c.comparator,
            parameters: c.parameters,
        })),
        actions: rule.actions.map((a) => ({
            type: a.type,
            parameters: a.parameters,
        })),
        evaluationMode: rule.evaluationMode,
    };
}
export function renderKerioFiltersPanel(options) {
    const wrap = el("div", "kerio-filters-panel");
    const toolbar = el("div", "inline-add");
    const saveBtn = el("button", "btn btn-primary btn-sm", "Save rules");
    saveBtn.type = "button";
    const reloadBtn = el("button", "btn btn-secondary btn-sm", "Reload");
    reloadBtn.type = "button";
    toolbar.append(saveBtn, reloadBtn);
    wrap.append(toolbar);
    const builderHost = el("div", "mt");
    wrap.append(builderHost);
    let dataStamp = 0;
    let rules = [];
    let selectedIndex = null;
    let dirty = false;
    const paint = () => {
        builderHost.replaceChildren(renderKerioBuilderUi({
            rules,
            selectedIndex,
            onChange: (next, sel) => {
                rules = next;
                selectedIndex = sel;
                dirty = true;
                paint();
            },
        }));
    };
    const load = async () => {
        options.showStatus("Loading Kerio filters…", "muted");
        try {
            const payload = await getKerioFilters(options.storage);
            dataStamp = payload.dataStamp;
            rules = payload.filters.map(fromApi);
            selectedIndex = rules.length ? 0 : null;
            dirty = false;
            paint();
            options.showStatus(`Loaded ${rules.length} rule(s).`, "success");
            wrap.querySelector(".kerio-password-update")?.remove();
        }
        catch (error) {
            const message = error instanceof Error ? error.message : "Failed to load filters";
            options.showStatus(message, "error");
            if (isKerioAuthError(message) && !wrap.querySelector(".kerio-password-update")) {
                wrap.append(renderKerioPasswordUpdate(options.storage, () => {
                    void load();
                }));
            }
        }
    };
    saveBtn.addEventListener("click", () => {
        void (async () => {
            options.showStatus("Saving Kerio filters…", "muted");
            try {
                const payload = await setKerioFilters(options.storage, dataStamp, rules.map(toApi));
                dataStamp = payload.dataStamp;
                rules = payload.filters.map(fromApi);
                dirty = false;
                paint();
                options.showStatus("Filters saved.", "success");
            }
            catch (error) {
                options.showStatus(error instanceof Error ? error.message : "Failed to save filters", "error");
            }
        })();
    });
    reloadBtn.addEventListener("click", () => {
        void load();
    });
    void load();
    return wrap;
}
export function isKerioFiltersDirty() {
    return false;
}
